import store from '@/store'
import translate from "../languages/index"

let lang = store.state.language || "pt"
export default {
  install(Vue) {
    Vue.prototype.$infoTable = {
      markets: function (id) {
        const markets = store.state.markets
        return markets.filter(item => item.id_market == id)[0]
      },
      outcomes: function (id) {
        const outcomes = store.state.results
        return outcomes.filter(item => item.id_outcome == id)[0]
      },
      results: function (result_event, status_event, odds_valid) {
        // apostas encerradas
        if (result_event == '2') {
          return 'encerrada';
        }

        // Only from agente 
        if (odds_valid == '0') {
          return 'invalida';
        }
        if (status_event == '0') {
          return 'cancelado';
        }

        if (result_event == '1') {
          return 'acertou';
        }

        if (result_event == '0' && result_event != null) {
          return 'errou';
        }

        if (result_event == '' || result_event == null) {
          return 'pendente';
        }

      },
      paid: function (id) {
        return id == '1' ? 'Sim' : 'Não'
      },
      conference: function (result_event, status_event, odds_valid) {
        let result = Vue.prototype.$infoTable.results(result_event, status_event, odds_valid);
        const conf = {
          cancelado: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content text">${translate[lang].cancel}</span></span>`,
          acertou: `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${translate[lang].right}</span></span>`,
          errou: `<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">${translate[lang].missed}</span></span>`,
          pendente: `<span class="my-1 v-chip theme--light v-size--small grey darken-3 white--text"><span class="v-chip__content">${translate[lang].pendent}</span></span>`,
          invalida: `<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">${translate[lang].invalid}</span></span>`,
          encerrada: `<span class="my-1 v-chip theme--light v-size--small lime darken-2 white--text"><span class="v-chip__content">${translate[lang].finished}</span></span>`,
        };
        return conf[result];
      },
      statusBet: function (status_bet) {
        const conf = {
          "0": `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content text">${translate[lang].cancel}</span></span>`,
          "1": `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${translate[lang].validated}</span></span>`,
          "2": `<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">${translate[lang].notValidated}</span></span>`,
        };
        return conf[status_bet] || '';
      },
    }
  }
}